import i18n from '@ohif/i18n';

const NS = 'RealtimeExam';

export function translatePlaneLabel(tag: string, fallbackLabel: string): string {
  return i18n.t(`planes.${tag}`, {
    ns: NS,
    defaultValue: fallbackLabel,
  });
}
